import { render, staticRenderFns } from "./5GTechnology.vue?vue&type=template&id=11cc83b6&scoped=true"
import script from "./5GTechnology.vue?vue&type=script&lang=js"
export * from "./5GTechnology.vue?vue&type=script&lang=js"
import style0 from "./5GTechnology.vue?vue&type=style&index=0&id=11cc83b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cc83b6",
  null
  
)

export default component.exports